module.exports = __webpack_public_path__ + "img/4-1.b4d97b68.svg";